<template>
    <div id="live_broadcast">
        <el-dialog title="签到成功" class="sign_dialog" :visible.sync="sign_dialog">
			<img :src='global.oss_website+"/pc/images/sign/sign_bg.jpg"' class="sign_bg">
			<i class="iconfont" @click="sign_dialog = false">&#xe61f;</i>
			<div class="sign_dialog_con">
				<p class="sign_title">{{ sign_title }}</p>
				<p class="sign_time">签到时间：{{sign_time_text}}</p>
				<img :src='global.oss_website+"/pc/images/sign/icon.png"' class="icon">
				<div class="sign_info">
					<p class="tips_tit">观看直播</p>
					<div class="douyin_box">
						<div class="img_box">
							<img :src="global.oss_website+now_live.qr_code">
						</div>
						<p class="operating_tips">打开{{pingtai}}<br>扫一扫观看直播</p>
					</div>
					<div class="password_box">
						<div class="password_con">{{now_live.key}}</div>
						<p class="operating_tips">复制口令<br>手机打开{{pingtai}}APP观看</p>
					</div>
				</div>
			</div>
		</el-dialog>
        <el-container>
            <el-breadcrumb separator-class="el-icon-arrow-right">
                <el-breadcrumb-item>当前位置</el-breadcrumb-item>
                <el-breadcrumb-item :to="{ path: '/web/' + this.$store.state.defaultIndex }">我的课程</el-breadcrumb-item>
                <el-breadcrumb-item>直播签到列表</el-breadcrumb-item>
            </el-breadcrumb>
	    </el-container>
        <div class="sign_in_list" v-loading="live_loading">
            <div class="titBox">
				<p class="tit">直播签到列表
					<!-- <font class="tit_tips">直播前15分钟开放签到</font>
					<el-link type="primary" class="see_more" @click="see_more">查看更多></el-link> -->
				</p>
			</div>
            <div class="sign_in_list_data" v-loading="sign_in_loading" v-if="sign_in_list.length>0">
                <div class="sign_in">
                    <div class="sign_in_neirong" v-for="(item,i) in sign_in_list" :key="i">
                        <img :src="item.cover == '----' ? pictureUrl:global.oss_website+item.cover" alt="">
                        <div class="text">
                            <p>
								<span class="state">{{item.condition}}</span>
								<span class="time">{{item.start_time}} - {{item.end_time.substring(item.end_time.length - 8)}}</span>
							</p>
                            <p class="sign_in_title" :title="item.title">{{item.title}}</p>
                            <p>
								<span class="teacher">讲师：{{item.lecturer}}</span>
								<span :class="is_sign(item,'class')" @click="sign_fn(item)">{{is_sign(item,'text')}}</span>
							</p>
                        </div>
                    </div>
                </div>
            </div>
			<div v-else class="nodata">
				<img :src="nodataImg">
				<p>暂无内容</p>
				<!-- 55 -->
			</div>
        </div>
		
    </div>
	
</template>
<script>
export default {
	name: 'index'
	,data () {
		return {
			live_loading:false,
            pingtai:'',
			sign_title: '恭喜你签到成功',
            sign_time_text:"",
            sign_dialog: false,
            sign_in_loading:false,
            sign_in_list:[],
            defaUlogo:this.global.oss_website+'/pc/images/ulogo.jpg',
            pictureUrl:this.global.oss_website+'/pc/images/course/courseImg.jpg',
            now_live:{
				qr_code:''
				,key:''
			}
		}
	}
	,created(){
		// let that = this
	}
	,mounted:function(){
		this.get_live_broadcast()
	}
	,methods:{
        //获取直播数据
		get_live_broadcast(){
			this.live_loading = true
			let that =this
			let url = this.global.serverSrc + this.global.qianzui + "/live_broadcast/list"
			this.$ajax.get(
				url
				,{
					params:{
						page:1
						,page_size:999
					}
				})
			.then(function(res){
				that.live_loading = false
                let resData = res.data
				if(resData.code==0){
                    // console.log(res);
                    that.sign_in_list = resData.data.data
				}else{
					that.$message.error('Σ(⊙▽⊙"a您所请求的服务器，目前正在外太空漂流~~~');
				}
				// that.live_list.loading = false
			})
		},
        //是否签到文字及样式返回
		is_sign(item, type){
			let clas = "",
				text = "",
				res
			let sign_start = new Date(Date.parse(item.sign_start.replace(/-/g,'/')))
				,sign_end = Date.parse(new Date(item.sign_end.replace(/-/g,'/')))
				,now_date = Date.parse(new Date())
			//现在时间 大于 签到开始时间 且 现在时间 大于 签到结束时间 且 为未签到状态
			if(now_date > sign_start && now_date < sign_end && item.is_sign == 0){
				clas = 'sign_in_state act'
			}else{
				clas = 'sign_in_state'
			}

			if(item.is_sign == 0){
				if(sign_end < now_date){
					text = '未签到'
				}else{
					text = item.platform == 3 ? '观看直播':'签到'
				}
			}else{
				text = item.platform == 3 ? '观看直播':'已签到'
			}
			if(type == "class"){
				res = clas
			}else if(type == "text"){
				res = text
			}
			return res
		},
        //点击签到
        addzero(time){
			let res = time
			if(time<10){
				res = '0'+time
			}
			return res
		},
        sign_fn(item){
			let that =this
			// 判断直播平台是否为学习平台
			if(item.platform == 3){
				// 非结束状态才可以进入直播间
				if(item.live && item.live.status != 5){
					this.$emit('jump',['/web/live/room', 'live_room', {id: item.id, live_id: item.live.id, room_num: item.live.room_num}])
				}else{
					this.$message.error('直播已结束');
				}
				return true
			}
            this.sign_in_loading = true
			//获取用户课程列表
			let url = this.global.serverSrc + this.global.qianzui + "/live_broadcast/add_sign"
			this.$ajax.post(
				url,
				that.$qs.stringify({
					id: item.id
				}))
			.then(function(res){
				// console.log(item);
                that.sign_in_loading = false
				// that.live_list.loading = false
				let resData=res.data;
				if(resData.code==0){	
					if(resData.data.created_at){
						that.pingtai=(item.platform==1?'抖音':'企业微信')
						that.sign_title = resData.message
						//签到时间时间
						that.sign_time_text = resData.data.created_at
					}else{
						// console.log(res);
						that.pingtai=(item.platform==1?'抖音':'企业微信')
						// console.log(that.pingtai);
						//计算当前时间
						let d = new Date()
							,day = `${d.getFullYear()}-${that.addzero(d.getMonth() + 1)}-${that.addzero(d.getDate())} `
							,time = `${that.addzero(d.getHours())}:${that.addzero(d.getMinutes())}:${that.addzero(d.getSeconds())}`
						that.sign_time_text = day + time
					}
				}else if(resData.code==1 || resData.code==2 || resData.code==3){
					//2：超过签到时间、3：未到签到时间
					that.$message.error(resData.message);
					return false;
				}else if(resData.code==401){
					that.$message.error('请求错误');
					return false;
				}else{
					that.$message.error('Σ(⊙▽⊙"a您所请求的服务器，目前正在外太空漂流~~~');
					return false;
				}
				//显示签到成功弹窗
				that.sign_dialog = true
				//绑定对应的数据
				that.now_live = item
				//绑定数据
				that.get_live_broadcast()
			})
		},
	}
}
</script>



// WEBPACK FOOTER //
// src/components/live/list.vue